import { PulseFilters, pulseFiltersSchema } from './types'

import { api } from 'api'
import { z } from 'zod'

const ratingsTimeseriesResponse = z.array(
  z.object({
    shift_date: z.string(),
    avg_worker_rating_by_shift: z.number(),
    avg_shift_rating_by_worker: z.number(),
  })
)

export type RatingsTimeseries = z.infer<typeof ratingsTimeseriesResponse>

export async function getRatingsTimeseries(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)
  return api
    .post('/company/pulse/performance/ratings_timeseries', data, { signal })
    .then((res) => res.data.ratings_timeseries)
}

export async function getRatingsTimeseriesCsv(
  filters: PulseFilters,
  signal?: AbortSignal
) {
  const data = pulseFiltersSchema.parse(filters)
  return api
    .post('/company/pulse/performance/ratings_timeseries/csv', data, { signal })
    .then((response) => response.data)
}
